// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"0c23a13d","95":"b69fd938","181":"9d378a07"}[chunkId] + ".css";
};